import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg" id="mainNavbar">
        <div className="container-fluid">
          <NavLink className="navbar-brand" to="/">
            <i className="fas fa-microphone-alt me-2"></i>
            科学声响
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <NavLink className="nav-link" to="/direct">
                  <i className="fas fa-bolt me-1"></i>直接执行
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/submit">
                  <i className="fas fa-paper-plane me-1"></i>提交任务
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/tasks">
                  <i className="fas fa-list-check me-1"></i>查看任务
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/viz">
                  <i className="fas fa-image me-1"></i>知识可视化
                </NavLink>
              </li>
            </ul>
            <ul className="navbar-nav">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="userDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  <i className="fas fa-user me-1"></i>
                  <span>{user?.nickname || user?.username || '用户'}</span>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink className="dropdown-item" to="/profile">
                      <i className="fas fa-user-circle me-2"></i>个人中心
                    </NavLink>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="#" onClick={handleLogout}>
                      <i className="fas fa-sign-out-alt me-2"></i>退出登录
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <main className="container-fluid py-3">
        <Outlet />
      </main>

      <div className="toast-container position-fixed bottom-0 end-0 p-3" id="toastContainer">
        <div className="toast" role="alert" id="toast">
          <div className="toast-header">
            <i className="fas fa-info-circle text-primary me-2"></i>
            <strong className="me-auto">系统提示</strong>
            <button type="button" className="btn-close" data-bs-dismiss="toast"></button>
          </div>
          <div className="toast-body" id="toastBody"></div>
        </div>
      </div>
    </>
  );
}